var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_17139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 36,
    height: 36,
    rx: 18,
    transform: "rotate(90 36 0)",
    fill: "#020A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4975 23.1225L18.375 16.245L25.2525 23.1225L27.375 21L18.375 12L9.375 21L11.4975 23.1225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_17139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 36,
    height: 36,
    rx: 18,
    transform: "rotate(90 36 0)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/topArrow.3995196b760dafe9bae31e276a406c2e.svg";
export { ForwardRef as ReactComponent };